import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Default axios instance. JWT auth flows over the `Authorization: Bearer` header
// (no cookies required), so we don't enable credentials globally — that combo
// with the platform ingress's wildcard CORS response would otherwise be
// rejected by the browser ("Allow-Origin: * not allowed with credentials").
export const api = axios.create({
  baseURL: API_BASE,
});

// Attach JWT bearer token (for email/password auth)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Per-request opt-in for cookie-based flows (Google OAuth session_token).
// Use only on endpoints that actually rely on `Set-Cookie` / cookie auth.
export const COOKIE_CREDENTIALS = { withCredentials: true };

export function setAuthToken(token) {
  if (token) localStorage.setItem("auth_token", token);
  else localStorage.removeItem("auth_token");
}

export function getAuthToken() {
  return localStorage.getItem("auth_token");
}

export function formatUSD(n) {
  if (n === null || n === undefined || isNaN(n)) return "$0";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 0,
  }).format(n);
}

export function formatUSDPrecise(n) {
  if (n === null || n === undefined || isNaN(n)) return "$0.00";
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    maximumFractionDigits: 2,
  }).format(n);
}
